<template>
  <div :style="`${loading ? 'height: 100%;' : 'opacity:1;'}`" class="dashboard-page">
    <!-- <div :style="getMiniDrawer ? `height: 50px;` : `height: 50px;`"> -->
    <loading-page v-if="loading"></loading-page>

    <!-- <default-page
      v-else-if="dashboardParamsSet < 4"
      imageUrl="/img/dynamic-src-images/dashboard.svg"
      title="Dashboard"
      :text="dashboardParamsSet == 0 ? 'Dashboard parameters are not set' : 'Not all dashboard parameters are set'"
      buttonText="Get Started"
      @button-clicked="
        isUserNoAlertCards ? createAlert() : getAlertTypes(true, true)
      "
      :noButtons="isUserNoAlertCards && !alertTypes.length"
    ></default-page> -->

    <div class="loading" v-else-if="dashboardParamsSet < 4">
      <v-container class="loading" fluid>
        <v-row>
          <v-col cols="12">
            <v-row align="center" justify="center" style="margin-top: 15%">
              <p
                  v-if="dashboardParamsSet === 0"
                  :class="{ 'light-text': !$vuetify.theme.dark }"
                  class="mb-2 text-center secondary-h1"
              >
                Dashboard parameters
                <br/>are not set
              </p>
              <p
                  v-else
                  class="mb-2 text-center secondary-h1"
                  style="font-size: 22px"
              >
                Not all dashboard
                <br/>parameters are set
              </p>
            </v-row>
            <p
                v-if="!isAdmin"
                class="text-center"
                style="letter-spacing: 0.02rem; font-size: 15px"
            >
              (Please refer to the Admin)
            </p>
            <v-row v-if="isAdmin" justify="center">
              <v-btn
                  color="primary"
                  large
                  style="font-family: Dosis,sans-serif; font-size: 16px; font-weight: 400"
                  class="mt-5"
                  @click="$router.push('/settings')"
              >
                Set parameters
              </v-btn
              >
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <default-page
        v-else-if="error"
        buttonText="Reload"
        button2Text="Change url"
        :errorMessage="error ? errorMessage : ''"
        customErrorText="There provided parameters led to an error"
        @button-clicked="reloadDashboard"
        @button2-clicked="$router.push('/settings')"
    ></default-page>

    <v-container v-else id="dashboard_container" fluid>
      <v-row class="row-class mx-0">
        <v-col
            cols="12"
            class="pa-0"
            :style="`height: 100%; background: ${
            $vuetify.theme.dark ? '#2e353b' : '#fff'
          };`"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-on="on"
                  v-bind="attrs"
                  rounded
                  class="primary reset-btn mt-1 mr-1"
                  icon
                  text
                  width="28"
                  height="28"
                  @click="setFrameUrl"
              >
                <v-icon style="font-size: 16px">fas fa-redo-alt</v-icon>
              </v-btn>
            </template>
            <span>Refresh</span>
          </v-tooltip>
          <iframe
              style="width: 100%; height: 100%"
              id="i_frame"
              :src="`${iframeUrl}`"
              frameborder="0"
              allowtransparency
          ></iframe>
          <v-overlay :value="overlay" color="#2e353b" absolute opacity="1" class="slow-overlay">
            <v-progress-circular
                :size="30"
                color="primary"
                indeterminate
            ></v-progress-circular>
          </v-overlay>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import axios from "axios";
import {
  LoadingPage,
  DefaultPage,
} from "../components/Default-Page-Components";

let refreshInterval;

export default {
  name: "dashboard",
  components: {LoadingPage, DefaultPage},
  data() {
    return {
      overlay: true,
      error: false,
      errorMessage: null,
      iframeUrl: "",
      loading: true,
      dashboardParamsSet: 0,
    };
  },
  computed: {
    getDashboardParams() {
      return this.getSpecificSetting({
        section: "general",
        innerSection: "dashboard",
      });
    },
    getTheme() {
      return this.$vuetify.theme.dark
          ? "#theme=night&bordered=false&titled=true"
          : "#bordered=true&titled=true";
    },
    ...mapGetters(["getMiniDrawer"]),
    ...mapGetters(["getSettings"]),
    ...mapGetters(["getSpecificSetting"]),
    ...mapGetters(["isAdmin"]),
  },
  methods: {
    addIframeListener() {
      let i = 0;
      const parent = this;

      const iframeInterval = setInterval(() => {
        i++;
        const iframe = document.getElementById("i_frame");
        if (iframe) {
          iframe.onload = function () {
            setTimeout(() => {
              parent.overlay = false;
            }, 500);
          };
        }
        if (i > 5 || iframe) {
          clearInterval(iframeInterval);
        }
      }, 100);
    },
    reloadDashboard() {
      this.loading = true;
      this.checkDashboardParameters();
    },
    loadFrame() {
      this.setFrameUrl(this.getDashboardParams);
      clearInterval(refreshInterval);
      refreshInterval = setInterval(() => {
        // this.overlay = true
        this.setFrameUrl(this.getDashboardParams);
      }, this.getDashboardParams.refresh_time * 1000);
    },
    setFrameUrl() {
      this.overlay = true;
      setTimeout(() => {
        let savedSettings = this.getDashboardParams;
        const jwt = require("jsonwebtoken");

        const METABASE_SITE_URL = savedSettings.url;
        const METABASE_SECRET_KEY = savedSettings.secret_key;

        const payload = {
          resource: {dashboard: this.getDashboardParams.number},
          params: {},
          exp: Math.round(Date.now() / 1000) + savedSettings.exp, // 10 minute expiration
        };
        const token = jwt.sign(payload, METABASE_SECRET_KEY);

        this.iframeUrl =
            METABASE_SITE_URL + "/embed/dashboard/" + token + this.getTheme;
      }, 500);
    },
    checkFrameUrl() {
      axios
          .get(this.getDashboardParams.url)
          .then(() => {
            this.loadFrame();
            this.loading = false;
            this.addIframeListener();
          })
          .catch((error) => {
            this.error = true;
            this.errorMessage = error.message;
            this.loading = false;
            this.addIframeListener();
          });
    },
    checkDashboardParameters() {
      this.loading = true;
      let savedSettings = this.getDashboardParams;
      this.dashboardParamsSet = 0;
      if (savedSettings.exp != null) {
        this.dashboardParamsSet++;
      }
      if (savedSettings.url !== "") {
        this.dashboardParamsSet++;
      }
      if (savedSettings.secret_key !== "") {
        this.dashboardParamsSet++;
      }
      if (savedSettings.number != null && !isNaN(savedSettings.number)) {
        this.dashboardParamsSet++;
      }
      if (this.dashboardParamsSet >= 4) {
        // check url for any errors -> loadFrame()
        // loadFrame() calls setFrameUrl() every refresh_time seconds
        this.checkFrameUrl();
      } else {
        this.loading = false;
        this.addIframeListener();
      }
    },
  },
  created() {
    this.loading = true;
    setTimeout(() => {
      // check dashboard parameters -> check if url gives any errors -> set iframe url
      this.checkDashboardParameters();
    }, 150);
  },
  watch: {
    getTheme() {
      this.setFrameUrl();
    },
  },
  beforeDestroy() {
    clearInterval(refreshInterval);
  },
};
</script>
<style scoped>
.reset-btn {
  position: fixed;
  z-index: 1;
  top: 65px;
  right: 20px;
  color: white;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  background-color: #1c6e59 !important;
}
</style>
<style>
.dashboard {
  width: 300px;
  height: 150px;
}

.row-class {
  width: 100%;
  height: 100%;
}

#dashboard_container.container {
  height: 100%;
  padding: 0;
}

.vue-grid-item.vue-grid-placeholder {
  background: none;
  border: dashed 2px #47bd96;
}

.dashboard-page {
  height: 100%;
}
</style>
